import React from "react";
import { Contract } from "@ethersproject/contracts";
import { ethers } from "ethers";
import { useEthers } from "@usedapp/core";
import { addresses, abis } from "@my-app/contracts";

import { SubmitButton } from "./styles";

const AllowanceChecker = ({ tokenIn, amount, onApproval }) => {
  const { library, account } = useEthers();

  const handleCheckAllowance = async () => {
    console.log("Checking allowance");
    if (!tokenIn || !amount || !account) return;
    const tokenInContract = new Contract(
      tokenIn,
      abis.erc20,
      library.getSigner()
    );
    const amountBN = ethers.utils.parseUnits(amount, "ether");
    const allowance = await tokenInContract.allowance(
      account,
      addresses.positionManager
    );

    if (allowance.lt(amountBN)) {
      const confirm = window.confirm(
        "Insufficient token allowance. Would you like to approve more tokens?"
      );
      if (confirm) {
        try {
          const approveTx = await tokenInContract.approve(
            addresses.positionManager,
            amountBN
          );
          await approveTx.wait();
          onApproval();
        } catch (error) {
          console.error("Error approving tokens", error);
        }
      }
    } else {
      onApproval();
    }
  };

  return (
    <SubmitButton onClick={handleCheckAllowance}>
      Check Allowance and Proceed
    </SubmitButton>
  );
};

export default AllowanceChecker;
